// PostHog init jest celowo opóźniony — patrz components/shared/deferred-analytics.tsx.
// Bootujemy SDK dopiero po requestIdleCallback lub pierwszej interakcji użytkownika,
// żeby nie trafiał na ścieżkę krytyczną LCP/TBT.
export {};
